import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function useSonicMigrateIntercept() {
  const location = useLocation();
  const [showAppStoreModal, setShowAppStoreModal] = useState(true);

  useEffect(() => {
    setShowAppStoreModal(true);
  }, [location.pathname, location.search]);

  const interceptAction = useCallback(() => {
    setShowAppStoreModal(true);
  }, []);

  return {
    showAppStoreModal,
    setShowAppStoreModal,
    interceptAction,
  };
}
